import { useCallback as t } from "react";
import { getPrefersReducedMotion as c } from "./use-prefers-reduced-motion.js";
const e = (o) => ({ scrollToItem: t(
  (r) => {
    var l;
    r !== null && ((l = o == null ? void 0 : o.current) != null && l[r]) && o.current[r].scrollIntoView({
      // read per call: usePrefersReducedMotion is still false during the first mount scroll
      behavior: c() ? "auto" : "smooth",
      inline: "nearest",
      block: "start"
    });
  },
  [o]
) });
export {
  e as useScrollIntoView
};
